import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

import {
  Dropdown,
  DropdownMenus,
} from 'src/app/services/dropdowns/dropdowns.model';
import { DropdownsService } from 'src/app/services/dropdowns/dropdowns.service';

/**
 * Contains the following {FormControl}s:
 * * EmploymentStatus
 */
@Component({
  selector: 'app-employment-status-info',
  templateUrl: './employment-status-info.component.html',
  styleUrls: ['./employment-status-info.component.scss'],
})
export class EmploymentStatusInfoComponent implements OnInit, OnDestroy {
  @Output() changeEvent = new EventEmitter<string>();
  @Input() controls: {
    [key: string]: AbstractControl;
  } = {};

  dropdownMenus: DropdownMenus | null = null;
  employmentStatus: Array<Dropdown> = [];

  private subscriptions: Array<Subscription> = [];

  constructor(private dropdownsService: DropdownsService) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.dropdownsService.dropdownMenus.subscribe(
        (data: DropdownMenus | null) => {
          if (data) {
            this.dropdownMenus = { ...data };
            this.employmentStatus = [...this.dropdownMenus.employmentStatuses];
          }
        }
      )
    );
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }

  getFormControl(key: string): FormControl {
    return this.controls[key] as FormControl;
  }

  controlIsRequired(key: string): boolean {
    if (
      this.controls[key] &&
      this.controls[key].hasValidator(Validators.required)
    ) {
      return true;
    }

    return false;
  }

  onChange(event: any) {
    this.changeEvent.emit(event.target.value);
  }
}
